import Axios from 'axios'
import config from '@/config/config.js'

// const baseUrl = 'http://192.168.119.122:8081'
const baseUrl = config.apiDomain.LC + (config.isProd ? '/b2/ali-core-util/' : '/b2/core-util/') + 'public-servant/api/g2e/staffAttendance/timetable/'
const absentInfoUrl = baseUrl + 'absentInfo/'

// Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
Axios.defaults.headers.timeout = 8000

export default {

  getAttendance (cb, startDate, endDate) {
    return new Promise((resolve, reject) => {
      Axios.get(baseUrl + startDate + '/' + endDate).then(
        response => {
          cb(response.data)
          resolve()
        },
        error => {
          console.error(error)
        }
      )
    })
  },

  getAbsentInfo (cb, startDate, endDate) {
    return new Promise((resolve, reject) => {
      Axios.get(absentInfoUrl + startDate + '/' + endDate).then(
        response => {
          cb(response.data)
          resolve()
        },
        error => {
          console.error(error)
        }
      )
    })
  }

}
